// extracted by mini-css-extract-plugin
export var container = "Offices-module--container--11a11";
export var wrapper = "Offices-module--wrapper--2b5a8";
export var layout = "Offices-module--layout--932f7";
export var mapWrap = "Offices-module--mapWrap--ceafc";
export var title = "Offices-module--title--f0994";
export var content = "Offices-module--content--1486f";
export var group = "Offices-module--group--2b63e";
export var groupTitle = "Offices-module--groupTitle--ce604";
export var list = "Offices-module--list--00533";
export var item = "Offices-module--item--50843";
export var flag = "Offices-module--flag--b4216";
export var showMobile = "Offices-module--showMobile--91f90";
export var showTablet = "Offices-module--showTablet--a90a9";